import { createContext } from "react";
import { ImportUpcStatus, UPCUploaderContextValues } from "../../types";

export const UPCUploaderContext = createContext<UPCUploaderContextValues>({
    errorMessages: {},
    isUploading: false,
    wasProcessed: false,
    hasDataToChange: false,
    importUpcStatus: ImportUpcStatus.NOT_STARTED,
    showTitleError: true,
});
